<template>
    <div>
        <img alt="Image" class="hero" src="../assets/Hero_img.png" />
        <div class="container" v-if="membershipType === 'FDX_MEMBER'">
            <div v-if="this.$store.state.pageState === 'WelcomeToFDX'">
                <div class="row">
                    <div class="col-sm">
                        <h5 class="text-left about"></h5>
                        <p class="text-left">
                            <span>
                                As you are part of
                                {{ this.companyName }}, we have added you under
                                the FDX Membership of
                                {{ this.companyName }}.<br />
                            </span>
                            <strong
                                >Here are a few bullets about actions we have
                                already taken to get you plugged in to FDX,
                                <u
                                    >as well as additional information or
                                    actions we need from you.</u
                                >
                                I have also notified our Marketing and
                                Communications team for a few of these
                                items.</strong
                            >
                        </p>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon1.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >Getting Started & Member
                                        Communication</strong
                                    ><br />
                                    Slack is a great way to communicate
                                    internally, and confluence will provide you
                                    with information, documents, meeting notes,
                                    updates and just about anything else you
                                    will ever need as an FDX member.<br />We
                                    suggest that you and anyone who will be
                                    involved in FDX from your organization
                                    please submit a
                                    <a
                                        class="target_links"
                                        href="https://financialdataexchange.org/FDX/Contact-Us.aspx"
                                        target="_blank"
                                        rel="noopener"
                                        >service ticket</a
                                    >
                                    with your colleagues names and email
                                    addresses so we can get you added our slack
                                    channel and to the FDX systems to receive
                                    FDX’s bi-weekly Digest and to register for
                                    various FDX events and Webinars. Finally,
                                    here are few Confluence links that will be
                                    of interest to you as a new member.
                                    <br /><br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/overview"
                                        target="_blank"
                                        rel="noopener"
                                        >Getting Started Confluence page</a
                                    >
                                    <br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/462225457/FDX+Task+Forces"
                                        target="_blank"
                                        rel="noopener"
                                        >List of Committees, Working Groups and
                                        Taskforces Confluence page </a
                                    ><br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/36601857/FDX+Member+List"
                                        target="_blank"
                                        rel="noopener"
                                        >Member page to create your
                                        organizational profile</a
                                    >
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon3.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >Meetings</strong
                                    ><br />
                                    We will be adding you to the calendar
                                    invites for the next New Member
                                    Orientation.<br />
                                    • Please use this link for
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/148832540/FDX+General+Members+Meetings"
                                        target="_blank"
                                        rel="noopener"
                                        >FDX General Member Meetings</a
                                    >. <br />
                                    • Please also look at
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/145752121/FDX+Committees+Working+Groups+and+Task+Forces"
                                        target="_blank"
                                        rel="noopener"
                                        >all the working groups and task
                                        forces</a
                                    >
                                    and let us know which ones you would like to
                                    join so we can add you to those invites as
                                    well.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon4.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >FDX Policy and Procedures</strong
                                    ><br />
                                    For any questions about FDX’s various
                                    policies and procedures, please review
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/849936406/FDX+Policies+and+Procedures"
                                        target="_blank"
                                        rel="noopener"
                                        >this</a
                                    >
                                    confluence page.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <p class="text-left">
                            <strong
                                >If you have any questions, please reach out to
                                <a style="color: #019382"
                                    >fdxsupport@financialdataexchange.org</a
                                >
                                – we are here to help!</strong
                            >
                        </p>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-sm">
                        <h5 class="text-left about"></h5>
                        <p class="text-left">
                            <strong
                                >Below you’ll find all the info necessary to get
                                up and running as soon as possible.</strong
                            >
                        </p>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon1.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >Getting Started & Member
                                        Communication</strong
                                    ><br />
                                    We have added you to Slack and Confluence.
                                    Slack is a great way to communicate
                                    internally, and confluence will provide you
                                    with information, documents, meeting notes,
                                    updates and just about anything else you
                                    will ever need as an FDX member.<br />In
                                    addition, we suggest that you and anyone who
                                    will be involved in FDX from your
                                    organization please submit a
                                    <a
                                        class="target_links"
                                        href="https://financialdataexchange.org/FDX/Contact-Us.aspx"
                                        target="_blank"
                                        rel="noopener"
                                        >service ticket</a
                                    >
                                    with your colleagues names and email
                                    addresses so we can get you added to our
                                    systems to receive FDX’s bi-weekly Digest
                                    and to register for various FDX events and
                                    Webinars.
                                    <br /><br />
                                    Finally, here are few Confluence links that
                                    will be of interest to you as a new member.
                                    (Please access your FDX Confluence account
                                    and create a username/password before these
                                    links will work.)<br /><br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/overview"
                                        target="_blank"
                                        rel="noopener"
                                        >Getting Started Confluence page</a
                                    >
                                    <br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/462225457/FDX+Task+Forces"
                                        target="_blank"
                                        rel="noopener"
                                        >List of Committees, Working Groups and
                                        Taskforces Confluence page </a
                                    ><br />
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/36601857/FDX+Member+List"
                                        target="_blank"
                                        rel="noopener"
                                        >Member page to create your
                                        organizational profile</a
                                    >
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon2.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >Points of Contact</strong
                                    ><br />
                                    Please send the following contacts for your
                                    organization to
                                    <span class="target_links"
                                        >srao@financialdataexchange.org.</span
                                    ><br />
                                    • Primary and Secondary Contacts – First and
                                    second leads for your organization’s
                                    membership in FDX<br />
                                    • PR & Corporate Communications Contact – We
                                    would like to work with the appropriate
                                    contact to promote your new membership and
                                    connect on various FDX announcements and
                                    news.<br />
                                    • Government & Regulatory Affairs Contact –
                                    If applicable, please send us the individual
                                    with primary responsibility for government
                                    affairs in your organization so we can
                                    ensure they are plugged in to the FDX
                                    Government Affairs working groups which
                                    seeks to educate policymakers and regulators
                                    on the work FDX is doing.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon3.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >Meetings</strong
                                    ><br />
                                    We will be adding you to the calendar
                                    invites for the next New Member
                                    Orientation.<br />
                                    • Please use this link for
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/148832540/FDX+General+Members+Meetings"
                                        target="_blank"
                                        rel="noopener"
                                        >FDX General Member Meetings</a
                                    >. <br />
                                    • Please also look at
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/145752121/FDX+Committees+Working+Groups+and+Task+Forces"
                                        target="_blank"
                                        rel="noopener"
                                        >all the working groups and task
                                        forces</a
                                    >
                                    and let us know which ones you would like to
                                    join so we can add you to those invites as
                                    well.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon4.png" />
                            </div>
                            <div class="contact-info text-left">
                                <p>
                                    <strong class="heading-level"
                                        >FDX Policy and Procedures</strong
                                    ><br />
                                    For any questions about FDX’s various
                                    policies and procedures, please review
                                    <a
                                        class="target_links"
                                        href="https://fdx.atlassian.net/wiki/spaces/FDX/pages/849936406/FDX+Policies+and+Procedures"
                                        target="_blank"
                                        rel="noopener"
                                        >this confluence page.</a
                                    >
                                </p>
                            </div>
                        </div>
                        <hr />
                        <div class="d-flex pb-4">
                            <div class="contact-icon">
                                <img alt="Image" src="../assets/icon5.png" />
                            </div>
                            <div class="contact-info text-left">
                                <strong class="heading-level"
                                    >Logo and URL for the FDX Website</strong
                                ><br />
                                <p>
                                    Please send an .ai or eps version of your
                                    logo to
                                    <span class="target_links"
                                        >srao@financialdataexchange.org</span
                                    >
                                    and I will make sure it gets uploaded to the
                                    site as soon as possible. Please also send
                                    your organizations URL as we link all member
                                    logos on our site to your own home page.
                                </p>
                            </div>
                        </div>
                        <hr />
                        <p class="text-left">
                            <strong
                                >If you have any questions, please reach out to
                                <a style="color: #019382"
                                    >fdxsupport@financialdataexchange.org</a
                                >–we are here to help!</strong
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-else>
            <div class="row">
                <div class="col-sm">
                    <h5 class="text-left about"></h5>
                    <hr />
                    <p class="text-left body">
                        <span
                            v-if="
                                this.$store.state.pageState === 'WelcomeToFDX'
                            "
                        >
                            As you are part of
                            {{ this.companyName }}, we have added you under the
                            {{ this.companyName }}
                            FDX Observer participation.<br />
                        </span>
                        You can access the FDX API through our
                        <a
                            href="https://developer.financialdataexchange.org/"
                            target="_blank"
                            rel="noopener"
                            >FDX Developer Portal</a
                        >. <br /><br />
                        <strong
                            >Please write to
                            <a style="color: #019382"
                                >fdxsupport@financialdataexchange.org</a
                            >
                            if you have any questions.
                        </strong>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WelcomeToFDX",
    data() {
        return {
            membershipType: null,
            companyName: "",
        };
    },
    created() {
        if (this.$store.state.Auth) {
            if (
                JSON.parse(this.$store.state.Auth.user).memberType === "SUS" ||
                JSON.parse(this.$store.state.Auth.user).memberType === "STD"
            ) {
                window.open(
                    "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                    "_self"
                );
                this.membershipType = "FDX_MEMBER";

            } else {
                window.open(
                    "https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx",
                    "_self"
                );
                this.membershipType = "FDX_OBSERVER";
            }
            this.companyName = JSON.parse(
                this.$store.state.Auth.user
            ).companyName;
        }
        if (JSON.parse(this.$store.state.user).membershipType) {
            this.membershipType = JSON.parse(
                this.$store.state.user
            ).membershipType;
            if (this.membershipType === "") {
                window.open(
                    "https://financialdataexchange.org/" + "FDX/FDX/MemberHome.aspx",
                    "_self"
                );
            } else {
                window.open(
                    "https://financialdataexchange.org/" + "FDX/FDX/FDX_API.aspx",
                    "_self"
                );
            }
            this.companyName = JSON.parse(
                this.$store.state.user
            ).organizationRequest.name;
        }
    },
};
</script>

<style>
.heading1 {
    font-weight: 500;
    font-size: 74px;
    line-height: 87px;
    color: #d0ffff;
    margin-left: 100px;
}
.nav-tabs {
    border-bottom: none;
}
.lead {
    font-weight: 400;
    font-size: 35px;
    line-height: 41px;
    color: #ffffff;
    margin-left: 100px;
}
.hero {
    width: -webkit-fill-available;
    height: 400px;
}
/* .jumbotron{
background-image:url('../assets/Hero_img.png');
background-position: left;
} */
.about {
    font-weight: 500;
    font-size: 34px;
    line-height: 41px;
    color: #1978a0;
}
.contact-info {
    margin-left: 28px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
hr {
    border: 1px solid #d8d8d8;
}
p {
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}
.heading-level {
    font-size: 18px;
    line-height: 24px;
}
.target_links {
    color: #019382;
    text-decoration: underline;
}
@media (max-width: 600px) {

    .hero {
        height: 200px !important;
    }

    .about {
        font-weight: 400  !important;
        font-size: 28px  !important;
        line-height: 31px  !important;
        padding-top: 20px  !important;
    }

}
</style>
